export class SearchSettingEntity {
  id?: number
  serviceId?: number
  serviceName?: string | null
  searchTimeToLive?: number
  searchRadius?: number
  busyDriversSearchRadius?: number
  assignDuration?: number
  startSearchBeforePreparationDuration?: number | null
  excludedDriversCacheTtlMinutes?: number
  maxPrepTimeMinutes?: number
  hotzoneRadiusMeters?: number
  onPeakPreparationDelayMinutes?: number
  offPeakPreparationDelayMinutes?: number
  offPeakSingleDispatchTriesBeforeStack?: number
  maxActiveOrdersPerDriver?: number
  stackWindowMinutes?: number
  stackMaxDistanceKm?: number
  stackMaxPrepTimeMinutes?: number
  diffCustomerDiffMerchantBusyMaxDistanceKm?: number
  diffCustomerDiffMerchantBusyMaxPrepTimeMinutes?: number
  diffCustomerDiffMerchantDeliveringMaxDistanceKm?: number
  diffCustomerDiffMerchantDeliveringMaxPrepTimeMinutes?: number
  radiusThreshold1?: number
  radiusThreshold2?: number
  radiusThreshold3?: number
  minSearchRadiusKm?: number
  mediumSearchRadiusKm?: number
  largeSearchRadiusKm?: number
  extraLargeSearchRadiusKm?: number
  radiusExpansionBatchTries?: number
  radiusExpansionKmBy?: number
  maxExpandedRadiusKm?: number
  preferBikeOverCar?: boolean
  sensitiveItemRequiresCar?: boolean
  companyMotorcyclePriorityEnabled?: boolean
  companyMotorcycleExtraRadiusKm?: number
}
